var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Flex, Typography, theme, Grid } from "antd";
import dayjs from "dayjs";
import { EVENT_ACTIONS, track } from "./../../../lib/gtag.js";
import { ReactComponent as ArrowLeft } from "./../../../assets/icons/arrow-left.svg";
import { ReactComponent as SummaryGoal } from "./../../../assets/icons/summary/summary_goal.svg";
import LiveStatusBox from "./../../../components/liveStatusBox/LiveStatusBox.js";
import FavoritesComponent from "./../../../components/favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../../components/favoritesComponent/favoritesService.js";
import "./fixtureDetailsHeader.css";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const TeamItem = ({ team, isDesktop, onClick }) => {
  const { token } = theme.useToken();
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      align: "center",
      gap: isDesktop ? 12 : 8,
      className: "fixture-header__team",
      onClick: () => onClick(team == null ? void 0 : team.id),
      children: [
        /* @__PURE__ */ jsx(
          Avatar,
          {
            src: team == null ? void 0 : team.iconUrl,
            shape: "square",
            size: isDesktop ? 64 : 48,
            style: { borderRadius: 0, flexShrink: 0 }
          }
        ),
        /* @__PURE__ */ jsx(
          Text,
          {
            style: {
              fontSize: isDesktop ? token.fontSizeLG : token.fontSizeSM,
              fontWeight: 500,
              textAlign: "center"
            },
            children: team == null ? void 0 : team.name
          }
        )
      ]
    }
  );
};
const ScoreCenter = ({ fixtureItem, liveContext, isDesktop }) => {
  const { token } = theme.useToken();
  const hasScore = liveContext && ![liveContext.homeScore, liveContext.awayScore].includes(null) && ![liveContext.homeScore, liveContext.awayScore].includes(void 0);
  return /* @__PURE__ */ jsxs(Flex, { vertical: true, align: "center", gap: 4, children: [
    /* @__PURE__ */ jsx("div", { className: "fixture-header__status", children: (fixtureItem == null ? void 0 : fixtureItem.isLive) ? /* @__PURE__ */ jsx(
      LiveStatusBox,
      {
        minutes: liveContext == null ? void 0 : liveContext.timeState,
        style: {
          fontSize: isDesktop ? token.fontSizeXL : token.fontSizeSM,
          fontWeight: 700
        }
      }
    ) : (fixtureItem == null ? void 0 : fixtureItem.isFinished) ? /* @__PURE__ */ jsx(
      Text,
      {
        style: {
          color: token.colorTextSecondary,
          fontFamily: token.secondaryFontFamily,
          fontSize: isDesktop ? token.fontSizeLG : token.fontSizeSM,
          fontWeight: 500
        },
        children: liveContext == null ? void 0 : liveContext.timeState
      }
    ) : null }),
    /* @__PURE__ */ jsx("div", { className: "fixture-header__score-box", children: /* @__PURE__ */ jsx(
      "span",
      {
        className: "fixture-header__score",
        style: {
          fontSize: isDesktop ? 32 : 20,
          lineHeight: isDesktop ? "32px" : "20px",
          color: token.colorTextBase
        },
        children: hasScore ? `${liveContext.homeScore}:${liveContext.awayScore}` : dayjs(fixtureItem == null ? void 0 : fixtureItem.startingAt).format("HH:mm")
      }
    ) }),
    /* @__PURE__ */ jsx(
      Text,
      {
        style: {
          color: token.colorTextSecondary,
          fontSize: isDesktop ? 10 : 8,
          whiteSpace: "nowrap"
        },
        children: dayjs(fixtureItem == null ? void 0 : fixtureItem.startingAt).format(
          isDesktop ? "MMMM D, YYYY" : "MMM D, YYYY"
        )
      }
    )
  ] });
};
const ScorerList = ({ scores, isHome, isDesktop }) => {
  const { token } = theme.useToken();
  const textStyle = {
    fontWeight: 500,
    fontSize: isDesktop ? token.fontSize : token.fontSizeXS
  };
  const icon = /* @__PURE__ */ jsx(
    SummaryGoal,
    {
      className: "fill-base",
      style: { flexShrink: 0, width: isDesktop ? 20 : 16 }
    }
  );
  return /* @__PURE__ */ jsx(
    Flex,
    {
      vertical: true,
      gap: isDesktop ? 8 : 6,
      align: isHome ? "end" : "start",
      style: { minWidth: 0, gridColumn: isHome ? 1 : 2 },
      children: scores == null ? void 0 : scores.map((score, index) => /* @__PURE__ */ jsxs(
        Flex,
        {
          gap: isDesktop ? 12 : 8,
          align: "center",
          style: { maxWidth: "100%" },
          children: [
            !isHome && icon,
            /* @__PURE__ */ jsx(
              Link,
              {
                to: `/player/${score.playerId}`,
                style: { minWidth: 0 },
                children: /* @__PURE__ */ jsxs(Flex, { gap: 4, align: "center", children: [
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      ellipsis: { tooltip: score.playerName },
                      style: __spreadProps(__spreadValues({}, textStyle), { minWidth: 0 }),
                      children: score.playerName
                    }
                  ),
                  /* @__PURE__ */ jsxs(Text, { style: __spreadProps(__spreadValues({}, textStyle), { flexShrink: 0 }), children: [
                    score.minuteAsString,
                    score.goalTypeString && ` (${score.goalTypeString})`
                  ] })
                ] })
              }
            ),
            isHome && icon
          ]
        },
        index
      ))
    }
  );
};
const FixtureDetailsHeader = ({ fixtureDetails, liveContext, children }) => {
  var _a, _b, _c, _d, _e, _f;
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = !!screens.md;
  const fixtureItem = fixtureDetails == null ? void 0 : fixtureDetails.fixtureItem;
  const venue = fixtureDetails == null ? void 0 : fixtureDetails.venue;
  const onTeamClick = (teamId) => {
    track(EVENT_ACTIONS.TEAM_DETAILS_FROM_MATCH_DETAILS);
    navigate(`/team/${teamId}`);
  };
  const onBackClick = () => {
    if (location.key === "default") {
      navigate("/");
    } else {
      navigate(-1);
    }
  };
  const favorites = /* @__PURE__ */ jsx(
    FavoritesComponent,
    {
      category: FAVORITE_CATEGORIES.MATCH,
      itemId: fixtureItem == null ? void 0 : fixtureItem.id,
      isFavorite: fixtureDetails == null ? void 0 : fixtureDetails.isFavorite,
      disabled: fixtureItem == null ? void 0 : fixtureItem.isFinished
    }
  );
  const scorers = ((_a = liveContext == null ? void 0 : liveContext.homesScores) == null ? void 0 : _a.length) || ((_b = liveContext == null ? void 0 : liveContext.awayScores) == null ? void 0 : _b.length) ? /* @__PURE__ */ jsxs("div", { className: "fixture-header__scorers", children: [
    /* @__PURE__ */ jsx(
      ScorerList,
      {
        scores: liveContext == null ? void 0 : liveContext.homesScores,
        isHome: true,
        isDesktop
      }
    ),
    /* @__PURE__ */ jsx(
      ScorerList,
      {
        scores: liveContext == null ? void 0 : liveContext.awayScores,
        isDesktop
      }
    )
  ] }) : null;
  const scoreboard = /* @__PURE__ */ jsxs("div", { className: "fixture-header__card", children: [
    /* @__PURE__ */ jsx(
      TeamItem,
      {
        team: fixtureItem == null ? void 0 : fixtureItem.home,
        isDesktop,
        onClick: onTeamClick
      }
    ),
    /* @__PURE__ */ jsx(
      ScoreCenter,
      {
        fixtureItem,
        liveContext,
        isDesktop
      }
    ),
    /* @__PURE__ */ jsx(
      TeamItem,
      {
        team: fixtureItem == null ? void 0 : fixtureItem.away,
        isDesktop,
        onClick: onTeamClick
      }
    ),
    !isDesktop && scorers
  ] });
  if (!isDesktop) {
    return /* @__PURE__ */ jsxs("div", { className: "fixture-header fixture-header--mobile", children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "fixture-header__hero",
          style: (venue == null ? void 0 : venue.imagePath) ? { backgroundImage: `url(${venue.imagePath})` } : void 0,
          children: /* @__PURE__ */ jsxs("div", { className: "fixture-header__hero-bar", children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "fixture-header__back",
                onClick: onBackClick,
                "aria-label": "Back",
                children: /* @__PURE__ */ jsx(ArrowLeft, {})
              }
            ),
            /* @__PURE__ */ jsx(
              Text,
              {
                ellipsis: true,
                className: "fixture-header__hero-title",
                style: { fontSize: token.fontSizeLG },
                children: (venue == null ? void 0 : venue.name) || ((_c = fixtureDetails == null ? void 0 : fixtureDetails.leagueInfo) == null ? void 0 : _c.name)
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "fixture-header__hero-action", children: favorites })
          ] })
        }
      ),
      scoreboard,
      children
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "fixture-header fixture-header--desktop", children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
      /* @__PURE__ */ jsx(Link, { to: `/league/${(_d = fixtureDetails == null ? void 0 : fixtureDetails.leagueInfo) == null ? void 0 : _d.id}`, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 16, children: [
        ((_e = fixtureDetails == null ? void 0 : fixtureDetails.leagueInfo) == null ? void 0 : _e.iconUrl) && /* @__PURE__ */ jsx(
          Avatar,
          {
            src: fixtureDetails.leagueInfo.iconUrl,
            shape: "square",
            style: {
              borderRadius: 0,
              height: 26,
              width: 26,
              flexShrink: 0
            }
          }
        ),
        /* @__PURE__ */ jsx(
          Text,
          {
            style: {
              color: token.colorTextBase,
              fontSize: token.fontSizeXL,
              fontWeight: 500
            },
            children: (_f = fixtureDetails == null ? void 0 : fixtureDetails.leagueInfo) == null ? void 0 : _f.name
          }
        )
      ] }) }),
      favorites
    ] }),
    scoreboard,
    scorers,
    children
  ] });
};
var stdin_default = memo(FixtureDetailsHeader);
export {
  stdin_default as default
};
